import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { NavConfigProvider } from '../../context/NavConfigContext';
import { claimAndPrintComande } from '../../lib/comande';
import { IncomingSupportModal } from '../common/IncomingSupportModal';
import { RemoteSessionBanner } from '../common/RemoteSessionBanner';

export const AppShell = () => {
  // La sidebar parte SEMPRE CHIUSA (collassata) ad ogni avvio dell'app: si apre
  // solo manualmente cliccando le tre linee. Non viene memorizzata, così all'ingresso
  // non si riapre mai da sola.
  const [collapsed, setCollapsed] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Auto-stampatore comande: qualunque dispositivo con una stampante raggiungibile
  // (ePOS Wi-Fi o principale) reclama e stampa le comande in sospeso, a prescindere
  // da dove nasce l'ordine (TPV, cameriere, ordini remoti). No-op senza stampante.
  useEffect(() => {
    let stopped = false;
    const tick = () => { if (!stopped) claimAndPrintComande(); };
    tick(); // subito all'avvio
    const iv = setInterval(tick, 3000);
    const onVis = () => { if (document.visibilityState === 'visible') tick(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { stopped = true; clearInterval(iv); document.removeEventListener('visibilitychange', onVis); };
  }, []);

  return (
    <NavConfigProvider>
      <div className="h-dvh flex bg-background overflow-hidden">
        <Sidebar
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          onCloseMobile={() => setMobileOpen(false)}
        />
        <div className="flex-1 flex flex-col min-w-0">
          <Topbar
            onToggleSidebar={() => setCollapsed((c) => !c)}
            onToggleMobile={() => setMobileOpen((o) => !o)}
          />
          <main className="flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
        {/* Pop-up globale: il gestore chiede di accedere a questo POS */}
        <IncomingSupportModal />
        <RemoteSessionBanner />
      </div>
    </NavConfigProvider>
  );
};
